// @ts-nocheck
import React from 'react';
import { useParams } from 'react-router-dom';
import TeamCheckInPanel from '@/components/checkin/TeamCheckInPanel';

const EventCheckInPage: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();
  return <TeamCheckInPanel eventId={eventId} />;
};

export default EventCheckInPage;
